export default {
  en: {
    editTermsAndConditions: 'Edit Terms & Conditions',
    newTermsAndConditions: 'New Terms & Conditions',
    save: 'Save',
    title: 'Title:',
    detail: 'Detail:',
    create: 'Create',
    cancel: 'Cancel'
  },
  th: {
    editTermsAndConditions: 'แก้ไขข้อตกลงและเงื่อนไข',
    newTermsAndConditions: 'เพิ่มรายการ',
    save: 'บันทึก',
    title: 'หัวข้อ:',
    detail: 'รายละเอียด:',
    create: 'เพิ่มใหม่',
    cancel: 'ยกเลิก'
  }
}
